import React, { useState } from "react";
import "./Header.css";
import real_logo from "./real_logo.png";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  MenuOutlined,
  BellOutlined,
  HomeOutlined,
  DashboardOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  NotificationOutlined,
  CalendarOutlined,
  TeamOutlined,
  BarChartOutlined,
  ShoppingCartOutlined,
  PieChartOutlined,
  CloudServerOutlined,
  FileTextOutlined,
  ToolOutlined,
  ShoppingOutlined
} from "@ant-design/icons";
import { Drawer, Badge, Dropdown, Menu, Avatar, Button } from "antd";

function Header() {
  const location = useLocation();
  const history = useHistory();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [notifications] = useState(3); // Mock notification count

  const user = JSON.parse(localStorage.getItem("Name")) || "User";
  const token = localStorage.getItem("acessToken");

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const userMenu = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: <Link to="/">My Profile</Link>,
      },
      {
        key: 'settings',
        icon: <SettingOutlined />,
        label: <Link to="/">Settings</Link>,
      },
      { type: 'divider' },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        danger: true,
        label: 'Logout',
        onClick: handleLogout,
      },
    ],
  };

  const notificationMenu = (
    <Menu className="notification-dropdown">
      <div className="notification-header">
        <h4>Notifications</h4>
        <Button type="link" size="small">Mark all as read</Button>
      </div>
      <Menu.Divider />
      <Menu.Item key="notif1">
        <div className="notification-item">
          <div className="notification-icon success">
            <BarChartOutlined />
          </div>
          <div className="notification-content">
            <p>Daily production report is ready</p>
            <span className="notification-time">2 min ago</span>
          </div>
        </div>
      </Menu.Item>
      <Menu.Item key="notif2">
        <div className="notification-item">
          <div className="notification-icon warning">
            <BellOutlined />
          </div>
          <div className="notification-content">
            <p>Machine maintenance due tomorrow</p>
            <span className="notification-time">1 hour ago</span>
          </div>
        </div>
      </Menu.Item>
      <Menu.Item key="notif3">
        <div className="notification-item">
          <div className="notification-icon info">
            <TeamOutlined />
          </div>
          <div className="notification-content">
            <p>Team meeting at 3 PM today</p>
            <span className="notification-time">2 hours ago</span>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="viewAll">
        <Link to="/notifications" className="view-all-notifications">
          View all notifications
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <header className="header">
        <div className="header-container">
          {/* Logo Section */}
          <div className="logo-section">
            <button className="menu-toggle" onClick={showDrawer}>
              <MenuOutlined />
            </button>
            <Link to="/Admin_dashboard" className="logo-link">
              <img src={real_logo} alt="Real Seating Systems" className="logo" />
              <div className="logo-text">
                <h1 className="company-name">Realform Technologies</h1>
                <span className="company-tagline">Foam For The Future</span>
              </div>
            </Link>
          </div>

          {/* Navigation Links (Desktop) */}
          <nav className="nav-links">
            <Link
              to="/Admin_dashboard"
              className={`nav-link ${location.pathname === '/Admin_dashboard' ? 'active' : ''}`}
            >
              <DashboardOutlined />
              <span>Dashboard</span>
            </Link>
            <Link
              to="/Production"
              className={`nav-link ${location.pathname === '/Production' ? 'active' : ''}`}
            >
              <BarChartOutlined />
              <span>Production</span>
            </Link>
            <Link
              to="/Scheduling"
              className={`nav-link ${location.pathname === '/Scheduling' ? 'active' : ''}`}
            >
              <CalendarOutlined />
              <span>Scheduling</span>
            </Link>
            <Link
              to="/Maintenance"
              className={`nav-link ${location.pathname === '/Maintenance' ? 'active' : ''}`}
            >
              <SettingOutlined />
              <span>Maintenance</span>
            </Link>
          </nav>

          {/* User Actions */}
          <div className="user-actions">
            {/* Notifications */}
            <Dropdown
              overlay={notificationMenu}
              trigger={['click']}
              placement="bottomRight"
            >
              <Button type="text" className="notification-btn">
                <Badge count={notifications} size="small">
                  <BellOutlined />
                </Badge>
              </Button>
            </Dropdown>

            {/* User Profile */}
            <Dropdown menu={userMenu} trigger={['click']} placement="bottomRight">
              <span onClick={e => e.preventDefault()}>
                <div className="user-profile">
                  <Avatar
                    size="large"
                    icon={<UserOutlined />}
                    className="user-avatar"
                  />
                  <div className="user-info">
                    <span className="user-name">{user.replace(/[{""}]/g, "")}</span>

                  </div>
                </div>
              </span>
            </Dropdown>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      <Drawer
        title={
          <div className="drawer-header">
            <img src={real_logo} alt="Logo" className="drawer-logo" />
            <span>Realform Technologies</span>
          </div>
        }
        placement="left"
        onClose={onClose}
        visible={drawerVisible}
        width={280}
        className="mobile-drawer"
      >
        <Menu mode="inline" className="drawer-menu">
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <Link to="/NewDashboard" onClick={onClose}>Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="PoData" icon={<FileTextOutlined />}>
            <Link to="/adddata" onClick={onClose}>Po Data</Link>
          </Menu.Item>
          <Menu.Item key="openorder" icon={<ShoppingCartOutlined />}>
            <Link to="/openorder" onClick={onClose}>Open Order</Link>
          </Menu.Item>
          <Menu.Item key="Pivot" icon={<PieChartOutlined />}>
            <Link to="/Pivot" onClick={onClose}>Pivot</Link>
          </Menu.Item>
          <Menu.Item key="scheduling" icon={<CalendarOutlined />}>
            <Link to="/Scheduling" onClick={onClose}>Scheduling</Link>
          </Menu.Item>
          <Menu.Item key="suppluchain" icon={<CloudServerOutlined />}>
            <Link to="/suppluchain" onClick={onClose}>Supply Chain</Link>
          </Menu.Item>
          <Menu.Item key="BOM" icon={<FileTextOutlined />}>
            <Link to="/BOM" onClick={onClose}>BOM</Link>
          </Menu.Item>
          <Menu.Item key="maintenance" icon={<ToolOutlined />}>
            <Link to="/Maintenance" onClick={onClose}>Maintenance</Link>
          </Menu.Item>
          <Menu.Item key="attendance" icon={<TeamOutlined />}>
            <Link to="/attendance" onClick={onClose}>Attendance</Link>
          </Menu.Item>
          <Menu.Item key="PurchaseRequest" icon={<ShoppingOutlined />}>
            <Link to="/PurchaseRequest" onClick={onClose}>Purchase Request</Link>
          </Menu.Item>
          <Menu.Item key="reports" icon={<FileTextOutlined />}>
            <Link to="/Getreport" onClick={onClose}>Reports</Link>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item key="logout" icon={<LogoutOutlined />} danger onClick={handleLogout}>
            Logout
          </Menu.Item>
        </Menu>
      </Drawer>
    </>
  );
}

export default Header;